import { useEffect, useState } from "react";
import { usePdpFocusedProduct, usePdpProduct } from "@/features/pdp/PdpContext";
import { ThumbnailGroup } from "./ThumbnailGroup";
import { CoverImage } from "@/components/CoverImage";
import React from "react";
import { ProductBadge } from "@/features/product/ProductBadge";
import { VideoModal } from "./VideoModal";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import { keyboardTrigger } from "@/helpers/utils";
import { IconButton } from "@mui/material";

export const ThumbnailGallery = () => {
  const product = usePdpProduct();
  const focusedProduct = usePdpFocusedProduct();
  const [selectedImageIndex, setSelectedImageIndex] = useState(0);
  const [open, setOpen] = useState(false);
  const handleClose = () => setOpen(false);
  // When the user selects a new products we will reset the selected image
  // to the product main one
  useEffect(() => {
    setSelectedImageIndex(0);
  }, [product]);

  const spotlightImage =
    focusedProduct != product || !product.media[selectedImageIndex]
      ? focusedProduct.media[0]
      : product.media[selectedImageIndex];

  const onThumbnailClick = (index: number) => {
    setSelectedImageIndex(index);
  };

  return (
    <div className="flex h-full">
      {spotlightImage.mediaType === "video" && (
        <VideoModal
          open={open}
          onClose={handleClose}
          videoItem={spotlightImage}
          productTitle={product.title}
        />
      )}
      <ThumbnailGroup
        onThumbnailClick={onThumbnailClick}
        selectedIndex={selectedImageIndex}
      />
      <div className="cover-image-container relative">
        <CoverImage
          alt={spotlightImage.alt ?? ""}
          src={spotlightImage.url}
          loading={selectedImageIndex === 0 ? "eager" : "lazy"}
          fetchPriority={selectedImageIndex === 0 ? "high" : "low"}
        />
        {focusedProduct.badge &&
          (focusedProduct.badge.text || focusedProduct.badge.image) &&
          (focusedProduct.badge.text ? (
            <ProductBadge text={focusedProduct.badge.text} size="lg" />
          ) : (
            selectedImageIndex === 0 && (
              <ProductBadge {...focusedProduct.badge} size="lg" />
            )
          ))}
      </div>
      {spotlightImage.mediaType === "video" && (
        <div className="absolute block h-full max-h-[588px] w-full">
          <IconButton
            size="large"
            aria-label="play video"
            color="inherit"
            onClick={() => setOpen(true)}
            onKeyDown={keyboardTrigger(() => setOpen(true))}
            className="group left-1/2 top-1/2 z-10 h-72 w-72 -translate-x-1/2 -translate-y-1/2 transform focus:outline-none focus-visible:ring-4 focus-visible:ring-primary-700 focus-visible:ring-opacity-75 "
          >
            <PlayCircleOutlineIcon className="h-full w-full transform text-white transition duration-500 group-hover:scale-110" />
          </IconButton>
        </div>
      )}
    </div>
  );
};
